import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLeftBar } from "../../context/LeftBar";
import NavItem from "./MenuItem/NavItem";
import WebIcon from "@mui/icons-material/Web";
import { ReactComponent as TargetLogo } from "../../assets/icons/target-logo.svg";
import InsightsIcon from "@mui/icons-material/Insights";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";

function LeftSideMenu({ app, config, logo }) {
	const [screenWidth, setScreenWidth] = useState(window.innerWidth);
	const [dataAtualizacao, setDataAtualizacao] = useState("");

	async function initialSelecao() {
		await app.variable.getContent("vAtualizacao", (reply) => {
			const data = reply.qContent.qString;
			setDataAtualizacao(data.substring(0, 10));
		});
	}

	useEffect(() => {
		initialSelecao();
		window.addEventListener("resize", () =>
			setScreenWidth(window.innerWidth)
		);

		return () => {
			window.removeEventListener("resize", () =>
				setScreenWidth(window.innerWidth)
			);
		};
	}, []);

	const { leftBarOpened, setLeftBarOpened } = useLeftBar();
	return (
		<div
			className={
				leftBarOpened ? "leftSideMenu is-opened" : "leftSideMenu"
			}
		>
			<div className="leftSideHeader">
				<div className={leftBarOpened ? "logo" : "logo is-hidden"}>
					<TargetLogo />
				</div>
				<button
					type="button"
					onClick={() => {
						setLeftBarOpened(!leftBarOpened);
					}}
					className={leftBarOpened ? "" : "align-left"}
				>
					<i
						className={
							leftBarOpened
								? "fal fa-arrow-left close-desktop"
								: "fal fa-arrow-right"
						}
					/>
					<i
						className={
							leftBarOpened ? "fal fa-times close-mobile" : ""
						}
					/>
				</button>
			</div>
			<div className="leftSideClientContainer">
				{leftBarOpened && (
					<>
						<div className="title">Cliente:</div>
						<div className="client-name">Hero</div>
					</>
				)}
			</div>
			<div className="leftSideContent">
				<ul>
					<NavItem
						muiIcon={<WebIcon />}
						name="One Page"
						path="/one-page"
					/>
				</ul>
				<ul>
					<NavItem
						muiIcon={<InsightsIcon />}
						name="Panorama"
						path="/panorama"
					/>
				</ul>
				<ul>
					<NavItem
						muiIcon={<SpaceDashboardOutlinedIcon />}
						name="Overview"
						path="/overview"
					/>
				</ul>
				<ul>
					<NavItem
						muiIcon={<TableViewIcon />}
						name="Detalhe"
						path="/detail"
					/>
				</ul>
				<ul>
					<NavItem
						muiIcon={<LocalOfferOutlinedIcon />}
						name="Produtos Estratégicos"
						path="/strategic-products"
					/>
				</ul>
				{leftBarOpened && (
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							width: "100%",
							paddingLeft: "10px",
							color: "white",
							justifyContent: "start",
							marginTop: "20px",
							fontSize: "14px",
						}}
					>
						<h4>Atualizado em: {dataAtualizacao} </h4>
					</div>
				)}
			</div>
		</div>
	);
}

LeftSideMenu.defaultProps = {
	app: null,
	config: {},
  };

LeftSideMenu.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default LeftSideMenu;
